import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLanguage } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Scuba from "@/pages/Scuba";

function setMetaTag(attr, key, content) {
  const selector = attr === "name" ? `meta[name=\"${key}\"]` : `meta[property=\"${key}\"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

function RouteMeta() {
  const { pathname } = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    const isScuba = pathname.startsWith("/scuba");

    const meta = isScuba
      ? {
          title: "Polvo Scuba — Dive Center & Scuba Shop",
          description:
            lang === "pt"
              ? "Polvo Scuba — centro de mergulho e loja de scuba na costa portuguesa."
              : "Polvo Scuba — dive center and scuba shop on the Portuguese coast.",
        }
      : {
          title: "Polvo — Information Security, Cloud & Networking",
          description:
            lang === "pt"
              ? "Polvo — consultoria em segurança da informação, serviços cloud e redes em Portugal."
              : "Polvo — information security, cloud services and networking consulting from Portugal.",
        };

    document.title = meta.title;
    setMetaTag("name", "description", meta.description);
    setMetaTag("property", "og:title", meta.title);
    setMetaTag("property", "og:description", meta.description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:url", `${window.location.origin}${pathname}`);
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", meta.title);
    setMetaTag("name", "twitter:description", meta.description);
  }, [pathname, lang]);

  return null;
}

function App() {
  useLenis();
  return (
    <LanguageProvider>
      <BrowserRouter>
        <RouteMeta />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/scuba" element={<Scuba />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </LanguageProvider>
  );
}

export default App;
